import React from 'react';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @Description Button component for various template types (text, line, rectangle, ellipse, and image).
 * @param {String} iconSrc - The source of the icon to be displayed inside the button (required).
 * @param {String} transferType - The type of the transfer for drag (required).
 * @param {Function} onClick - The click event handler (optional).
 * @param {Function} onDragStart - The drag start event handler (optional).
 * @param {String} className - Additional CSS classes for styling (optional).
 * @param {String} altText - Alt text for the image (required).
 * @returns {JSX.Element}
 */
const CustomTemplateButton = ({ iconSrc, transferType, onClick, onDragStart, className = '', altText }) => {
    return (
        <button
            className={`button-option btn ${className}`}
            draggable
            onDragStart={(e) => onDragStart(e, transferType)}
            data-transfer-type={transferType}
            onClick={onClick}
        >
            <img className="" src={iconSrc} alt={altText} />
        </button>
    );
};

export default CustomTemplateButton;
